function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.95 2.05a1 1 0 01.243 1.02l-3.95 12.02a1 1 0 01-1.87.08L6.117 9.884.829 7.627a1 1 0 01.08-1.87l12.022-3.95a1 1 0 011.019.243z",
  fill: "#fff"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy45NDk4IDIuMDUwMjZDMTQuMjE2NSAyLjMxNyAxNC4zMTA1IDIuNzExMTQgMTQuMTkyNyAzLjA2OTUyTDEwLjI0MyAxNS4wOTAzQzEwLjExMzEgMTUuNDg1OCA5Ljc1MTc1IDE1Ljc1OTQgOS4zMzU4OSAxNS43NzczQzguOTIwMDQgMTUuNzk1MSA4LjUzNjU5IDE1LjU1MzUgOC4zNzMyMSAxNS4xNzA3TDYuMTE2NyA5Ljg4MzM2TDAuODI5MzYxIDcuNjI2ODVDMC40NDY1MjYgNy40NjM0NyAwLjIwNDkzMyA3LjA4MDAyIDAuMjIyODA3IDYuNjY0MTdDMC4yNDA2ODIgNi4yNDgzMSAwLjUxNDI4NiA1Ljg4NzAxIDAuOTA5NzI4IDUuNzU3MDhMMTIuOTMwNSAxLjgwNzMzQzEzLjI4ODkgMS42ODk1OCAxMy42ODMxIDEuNzgzNTEgMTMuOTQ5OCAyLjA1MDI2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgLocation as ReactComponent };